import { CarrierOptimizationsActionTypes } from './constants';

type CarrierOptimizationsAction = { type: string, payload: {} | string };

export const carrierOptimizationsApiResponseSuccess = (actionType: string, data: any): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const carrierOptimizationsApiResponseError = (actionType: string, error: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const carrierOptimizationsGetOptimizedCarriers = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS,
    payload: { query },
});

export const carrierOptimizationsGetOptimizedTransitTimeByDayServiceLevel = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL,
    payload: { query },
});

export const carrierOptimizationsGetTotalCost = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_TOTAL_COST,
    payload: { query },
});

export const carrierOptimizationsGetAvgCost = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_AVG_COST,
    payload: { query },
});

export const carrierOptimizationsGetOptimizedTotalCost = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST,
    payload: { query },
});

export const carrierOptimizationsGetOptimizedAvgCost = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST,
    payload: { query },
});

export const carrierOptimizationsGetOptimizedAggregatedCostByService = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE,
    payload: { query },
});

export const carrierOptimizationsGetOptimizedShipFromLocations = (query: string): CarrierOptimizationsAction => ({
    type: CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS,
    payload: { query },
});